import * as t from "io-ts";
import {Exclude, Expose, instanceToPlain, plainToInstance, Transform} from "class-transformer";
import {validateJSON, validateJSONNow} from "../web/validation";
import {Entity} from "./entity";
import {getDatabaseCodeTransformer} from "./transfomers/transformers";
import {CargoSubtype, toCargoSubtype} from "./cargo-subtype";

export const ContainerVolumeDropValidator = t.intersection([
  t.type({
    id: t.string,
    containerId: t.string,
    volume: t.number,
    volumeTop: t.number,
    volumeBottom: t.number,
    fillRate: t.number,
    unitOfMeasure: t.string,
    cargoSubtype: t.string,
    regionId: t.string,
    startDttm: t.number,
    endDttm: t.number,
  }),
  t.partial({
    volume2: t.number,
    volume2Top: t.number,
    volume2Bottom: t.number,
    fillRate2: t.number,
    createDttm: t.number,
    lastModifiedDttm: t.number,

    containerName: t.string,
    containerClusterId: t.string,
    containerClusterName: t.string,
    siteId: t.string,
    siteName: t.string,
    siteCompanyId: t.string,
    siteCompanyName: t.string,
  }),
]);

export const ContainerVolumeDropArrayValidator = t.array(ContainerVolumeDropValidator);

export type ContainerVolumeDrop = t.TypeOf<typeof ContainerVolumeDropValidator>;
export type ContainerVolumeDropArray = t.TypeOf<typeof ContainerVolumeDropArrayValidator>;

@Exclude()
export class ContainerVolumeDropEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  containerId!: string;

  @Expose()
  containerName?: string;

  @Expose()
  containerClusterId?: string;

  @Expose()
  containerClusterName?: string;

  @Expose()
  siteId?: string;

  @Expose()
  siteName?: string;

  @Expose()
  siteCompanyId?: string;

  @Expose()
  siteCompanyName?: string;

  @Expose()
  volume!: number

  @Expose()
  volumeTop!: number

  @Expose()
  volumeBottom!: number

  @Expose()
  fillRate!: number

  @Expose()
  volume2?: number

  @Expose()
  volume2Top?: number

  @Expose()
  volume2Bottom?: number

  @Expose()
  fillRate2?: number

  @Expose()
  createDttm?: number;

  @Expose()
  unitOfMeasure?: string;

  @Expose()
  @Transform(getDatabaseCodeTransformer(toCargoSubtype))
  cargoSubtype?: CargoSubtype;

  @Expose()
  regionId!: string;

  @Expose()
  startDttm!: number;

  @Expose()
  endDttm!: number;

  @Expose()
  lastModifiedDttm?: number;

  readonly entityType = 'CONVOLDROP';

  get displayName(): Readonly<string> {
    return this.id;
  }

  /**
   * Constructor for ContainerVolumeDropEntity. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: ContainerVolumeDrop): ContainerVolumeDropEntity {
    return plainToInstance(ContainerVolumeDropEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<ContainerVolumeDrop> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(ContainerVolumeDropValidator, object);
  }

  asTypeValue(): ContainerVolumeDrop {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(ContainerVolumeDropValidator, object);
  }
}
